import React, { useEffect } from 'react'
import GenerateIcon, { IconTypes } from '../../components/GenerateIcon'


interface IProps {
    selectedType: string,
    handleSelectedType: (type: string) => void,
    useRequestsTypes?: boolean
}

interface ITransactionAction {
    type: string,
    label: string,
    icon: IconTypes
}

export default function SelectTransactionActions(props: IProps) {

    const { selectedType, handleSelectedType, useRequestsTypes } = props

    const items: Array<ITransactionAction> = !useRequestsTypes ? [
        {
            type: "taken",
            label: "Use",
            icon: "transfer"
        },
        {
            type: "returned",
            label: "Return",
            icon: "done"
        },
        {
            type: "transferred",
            label: "Transfer",
            icon: "move"
        }
    ] : [
        {
            type: "use",
            label: "Use",
            icon: "transfer"
        },
        {
            type: "move",
            label: "Transfer",
            icon: "move"
        }
    ]

    const renderSingleItem = (item: ITransactionAction, index: number) => {

        const returnContainerClassname = (name: string) => {
            return name
        }

        return(
            <div onClick={() => handleSelectedType(item.type)} className={item.type == selectedType ? returnContainerClassname("single-transaction-type-item active") : returnContainerClassname("single-transaction-type-item")} key={index}>
                <div className="content-of-single-transaction-type-item">

                    <GenerateIcon icon={item.icon} />

                    <h3>{item.label}</h3>

                </div>
            </div>
        )
    }


    return(
        <div className="select-types-container">
            <div className="content-of-select-types-container">
                {items.map((item, index) => renderSingleItem(item, index))}
            </div>
        </div>
    )
}